const quickLinks = [
  { label: "平台介绍", href: "#features" },
  { label: "分类指南", href: "#genres" },
  { label: "画风解析", href: "#styles" },
  { label: "题材推荐", href: "#recommend" },
  { label: "阅读指南", href: "#reading" },
  { label: "常见问题", href: "#faq" },
];

const systems = ["韩漫 · 竖屏全彩", "日漫 · 分格叙事", "国漫 · 国风全彩"];

const topics = [
  "罗曼史 / 都市情感",
  "热血冒险 / 奇幻异世界",
  "玄幻仙侠 / 悬疑推理",
  "校园青春 / 治愈日常",
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 px-4 md:px-6 pt-14 pb-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg flex items-center justify-center bg-primary-500 text-background-50">
                <i className="ri-book-2-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">漫蛙</span>
            </div>
            <p className="mt-4 text-sm text-background-200/85 leading-relaxed">
              一份围绕韩漫、日漫、国漫的全彩漫画分类指南，帮你按体系、画风与题材快速定位想看的作品。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">页面导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-background-200/85 cursor-pointer hover:text-primary-300 transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">漫画体系</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {systems.map((s) => (
                <li key={s} className="text-sm text-background-200/85 flex items-center gap-2">
                  <i className="ri-book-marked-line text-primary-400"></i>
                  {s}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">热门题材</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {topics.map((t) => (
                <li key={t} className="text-sm text-background-200/85 flex items-center gap-2">
                  <i className="ri-price-tag-3-line text-accent-400"></i>
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs md:text-sm text-background-200/70 text-center sm:text-left">
            © 2026 漫蛙 · 全彩漫画分类指南。本站为内容分类参考，不提供漫画正文，也不收集账号与支付信息。
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs md:text-sm text-background-200/85 cursor-pointer hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}